import React, { useState } from 'react';

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you for your message! We\'ll get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Contact Us</h1>
        <p className="page-subtitle">We'd love to hear from you</p>
      </div>

      <div className="page-content">
        <div className="contact-content">
          <div className="contact-info">
            <section className="content-section">
              <h2>Get In Touch</h2>
              <p>
                Have a question, suggestion, or need support? We're here to help!
                Reach out to us using the form below or through any of our contact methods.
              </p>
            </section>

            <section className="content-section">
              <h2>Contact Information</h2>
              <div className="contact-details">
                <div className="contact-item">
                  <strong>Email:</strong>
                  <p>support@flow-writing.com</p>
                </div>
                <div className="contact-item">
                  <strong>Response Time:</strong>
                  <p>We typically respond within 24 hours</p>
                </div>
                <div className="contact-item">
                  <strong>Business Hours:</strong>
                  <p>Monday - Friday, 9:00 AM - 6:00 PM EST</p>
                </div>
              </div>
            </section>

            <section className="content-section">
              <h2>What We Can Help With</h2>
              <ul>
                <li>Technical support and troubleshooting</li>
                <li>Account and billing questions</li>
                <li>Feature requests and suggestions</li>
                <li>Partnership and collaboration inquiries</li>
                <li>General questions about Flow</li>
              </ul>
            </section>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2>Send Us a Message</h2>

              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select a topic</option>
                  <option value="technical-support">Technical Support</option>
                  <option value="billing">Billing Question</option>
                  <option value="feature-request">Feature Request</option>
                  <option value="partnership">Partnership Inquiry</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Tell us how we can help you..."
                  required
                />
              </div>

              <button type="submit" className="submit-button">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;